export function obterIdentidadeUsertour(
	grupo: number | null | undefined,
	pessoa: number | null | undefined,
): string | null {
	const grupoValido = typeof grupo === "number" && Number.isInteger(grupo) && grupo > 0;
	const pessoaValida = typeof pessoa === "number" && Number.isInteger(pessoa) && pessoa !== 0;

	return grupoValido && pessoaValida ? `${grupo}:${pessoa}` : null;
}
